import { FC } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { UsBrandNames } from 'src/enums';
import globalMessages from 'src/messages';
import { phoneLink } from 'src/utils/intlHelper';

import { ElMonteEmailUrl, RoadBearEmailUrl } from 'src/constants';

import { ContactItem, ContactItemHeader, ContactWrapper } from './Contact';
import { EmailUsLink } from './Footer';
import msg from './footerMessages';

const ContactItemsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
`;

const ContactNumber = styled.div`
    a {
        color: ${({ theme: { colors } }) => colors.white};
    }
    color: ${({ theme: { colors } }) => colors.white};
    text-wrap: nowrap;
    font-size: 1.5rem;
    font-weight: bold;
`;

const ContactUS: FC<{ brandName: UsBrandNames }> = ({ brandName }) => {
    const intl = useIntl();
    const isRoadBear = brandName === UsBrandNames.roadBear;

    let emailUsLink = '';
    
    if (isRoadBear) {
        emailUsLink = RoadBearEmailUrl;
    } else {
        emailUsLink = ElMonteEmailUrl;
    } 

    return (
        <ContactWrapper>
            <ContactItem>
                <ContactItemHeader>
                    <span>{intl.formatMessage(msg.footer.needHelp)}</span>
                </ContactItemHeader>
                <ContactItemsContainer>
                    <ContactNumber>
                        <span>
                            {intl.formatMessage(
                                isRoadBear
                                    ? globalMessages.phones.roadBearTollFreePhone
                                    : globalMessages.phones.elmonteTollFreePhone,
                                {
                                    a: phoneLink,
                                },
                            )}
                        </span>
                    </ContactNumber>
                    <ContactNumber>
                        <span>
                            {intl.formatMessage(
                                isRoadBear
                                    ? globalMessages.phones.roadBearInternationalPhone
                                    : globalMessages.phones.elmonteInternationalPhone,
                                {
                                    a: phoneLink,
                                },
                            )}
                        </span>
                    </ContactNumber>
                    <EmailUsLink
                        href={emailUsLink}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {intl.formatMessage(msg.footer.emailUs)}
                    </EmailUsLink>
                </ContactItemsContainer> 
            </ContactItem>  
        </ContactWrapper>
    );
};

export default ContactUS;
